import React, { useState, useEffect, useRef } from 'react';

const Stopwatch = ({ onClose }) => {
  const [startTime, setStartTime] = useState(null);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [runningTime, setRunningTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const start = () => {
    if (startTime === null) {
      const now = Date.now();
      setStartTime(now);
      setIsRunning(true);

      intervalRef.current = setInterval(() => {
        setRunningTime(Date.now() - now);
      }, 70);
    }
  };

  const stop = () => {
    if (startTime === null) {
      return;
    }

    if (isRunning) {
      clearInterval(intervalRef.current);
      setElapsedTime(prev => prev + runningTime);
      setStartTime(null);
      setRunningTime(0);
      setIsRunning(false);
    }
  };

  const reset = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    setElapsedTime(0);
    setRunningTime(0);
    setStartTime(null);
    setIsRunning(false);
  };

  const formatTime = (milliseconds) => {
    const totalMs = milliseconds;
    const minutes = Math.floor(totalMs / 60000);
    const seconds = Math.floor((totalMs % 60000) / 1000);
    const ms = Math.floor((totalMs % 1000) / 10);

    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}.${ms.toString().padStart(2, '0')}`;
  };

  const currentTime = elapsedTime + runningTime;

  return (
    <div>
      <div className="text-center">
        <h4>Stopwatch</h4>
        <div className="mt-4 mb-4">
          <div 
            style={{
              fontSize: '3rem',
              fontFamily: 'monospace',
              fontWeight: 'bold',
              backgroundColor: '#f8f9fa',
              padding: '20px',
              borderRadius: '10px',
              border: '2px solid #dee2e6',
              color: '#495057'
            }}
          >
            {formatTime(currentTime)}
          </div>
        </div>

        <div className="d-flex justify-content-center gap-3">
          <button 
            className={`btn btn-lg ${isRunning ? 'btn-warning' : 'btn-success'}`}
            onClick={isRunning ? stop : start}
          >
            {isRunning ? 'Stop' : 'Start'}
          </button>
          
          <button 
            className="btn btn-lg btn-danger"
            onClick={reset}
            disabled={currentTime === 0}
          >
            Reset
          </button>
        </div>

        <div className="mt-4">
          <div className="row">
            <div className="col-md-6">
              <div className="card">
                <div className="card-body text-center">
                  <h6 className="card-title">Lap Time</h6>
                  <p className="card-text" style={{ fontSize: '1.5rem', fontFamily: 'monospace' }}>
                    {formatTime(runningTime)}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card">
                <div className="card-body text-center">
                  <h6 className="card-title">Total Time</h6>
                  <p className="card-text" style={{ fontSize: '1.5rem', fontFamily: 'monospace' }}>
                    {formatTime(elapsedTime)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4">
          <h6>Instructions:</h6>
          <ol className="text-start">
            <li>Click <strong>Start</strong> to begin timing</li>
            <li>Click <strong>Stop</strong> to pause the timer</li>
            <li>Click <strong>Start</strong> again to resume</li>
            <li>Click <strong>Reset</strong> to clear all times</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default Stopwatch;
